<template>
  <header class="glass-morphism border-b border-white/10 sticky top-0 z-40">
    <div class="container mx-auto px-6 py-4">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <div class="relative">
            <img src="https://www.fvv-net.de/fileadmin/FVV/FVV-Logo-White.png" alt="FVV Logo" class="h-12 filter drop-shadow-lg">
          </div>
          <div>
            <h1 class="text-2xl font-bold text-white">Event-Check-In</h1>
          </div>
        </div>
      </div>  
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <div class="glass-morphism rounded-lg p-1 flex mt-2">
            <button 
              @click="$emit('view-change', 'list')"
              :class="currentView === 'list' ? 'btn-primary text-white' : 'text-gray-300 hover:text-white'"
              class="px-4 py-1 rounded-lg transition-all duration-300 font-medium flex items-center space-x-1 text-sm"
            >
              <i class="fas fa-users"></i>
              <span>Gäste Liste</span>
            </button>
          </div>
          <div class="glass-morphism rounded-lg p-1 flex mt-2">
            <button 
              @click="$emit('open-scanner')"
              class="px-4 py-1 rounded-lg transition-all duration-300 font-medium flex items-center space-x-1 text-sm btn-primary text-white"
            >
              <i class="fas fa-qrcode"></i>
              <span>QR Scannen</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
    currentView: {
      type: String,
      default: 'list'
    }
  },
  emits: ['view-change', 'open-scanner']
}
</script>
